import { isFunction } from "@util/utils";
import { getClientRect } from "@util/web-utils";

/**
 *
 * @param clearable
 */
export function tryToClear(clearable: any) {
  clearable && isFunction(clearable.clear) && clearable.clear();
}

export function setByDialogHeight(elem?: HTMLElement) {

  if (!elem) {
    return;
  }

  const dialogs = document.getElementsByClassName('my-document-dialog');
  if (dialogs.length) {
    const d = dialogs.item(0);
    if (d) {
      const dc = d.getElementsByClassName('mat-dialog-container');
      if (dc.length) {
        const r = getClientRect(dc.item(0));
        if (r) {
          const wh = r.height;
          elem.style.height = (wh - 2 * 24 - 32 - 50) + 'px';
          //elem.style.maxHeight = elem.style.height;
        }
      }
    }
  }
}

/*
interface ISetImgContent {
  setImgContent(id: any): void;
}

function setImgContent(
  component: ISetImgContent,
  img: any,
  content: any,
  orderId: any
) {
  if (hasFileReader() && img) {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64data = reader.result;
      img.src = base64data;
    };

    reader.readAsDataURL(content);
  } else {
    component.setImgContent(orderId);
  }
}
*/
